// Typography.
//
// Body: Jost — geometric, Bauhaus-lineage. The previous body face was Inter,
// which is on the anti-slop ban list and is the most recognisable "AI
// default" type tell.
// Display: Archivo Narrow — Dr Non's contemporary editorial pick for large
//   display numerics (Bangkok temp, flood score, hero stats).
// Thai: Prompt — a geometric Thai face that sits with Jost. The old stack
//   named "Noto Sans Thai", which was never loaded, so Thai text was being
//   rasterised in the macOS system face.
// Mono: JetBrains Mono — Palette's pick for character-cell–aligned
//   numeric readouts.
import "@fontsource/jost/400.css";
import "@fontsource/jost/500.css";
import "@fontsource/jost/600.css";
import "@fontsource/prompt/400.css";
import "@fontsource/prompt/500.css";
import "@fontsource/prompt/600.css";
import "@fontsource/archivo-narrow/400.css";
import "@fontsource/archivo-narrow/500.css";
import "@fontsource/archivo-narrow/600.css";
import "@fontsource/archivo-narrow/700.css";
import "@fontsource/jetbrains-mono/400.css";
import "@fontsource/jetbrains-mono/500.css";
import "@fontsource/jetbrains-mono/600.css";
import "@fontsource/jetbrains-mono/700.css";

import "./styles/tokens.css";
import "./styles/layout.css";
import "maplibre-gl/dist/maplibre-gl.css";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { ErrorBoundary } from "./components/ErrorBoundary";

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("#root element not found");
createRoot(rootEl).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
);
